import clsx from 'clsx';
import React, { useCallback } from 'react';

import AutomationBanner from './AutomationBanner';
import AutomationProcessingButton from './AutomationProcessingButton';

import ActionButton from '../../Elements/ActionButton/ActionButton';
import DeleteDraftButton from '../../Elements/DeleteDraftButton/DeleteDraftButton';
import TreatmentHeader from '../TreatmentForm/TreatmentFormLayout/TreatmentHeader';
import useTreatmentConfirmModals from '../TreatmentForm/useTreatmentConfirmModals';
import TreatmentLayout from '../TreatmentLayout/TreatmentLayout';

type AutomationProcessingViewProps = {
  onCancelAutomation: () => void;
};

const AutomationProcessingView = ({ onCancelAutomation }: AutomationProcessingViewProps) => {
  const { CancelAutomationModal, confirmCancelAutomation } = useTreatmentConfirmModals();

  const handleCancelAutomation = useCallback(async () => {
    if (!(await confirmCancelAutomation())) {
      return;
    }
    onCancelAutomation();
  }, [confirmCancelAutomation, onCancelAutomation]);

  const Header = (
    <TreatmentHeader title="New Expense">
      <DeleteDraftButton isDisabled={true} />
      <AutomationProcessingButton />
    </TreatmentHeader>
  );

  const Banner = (
    <AutomationBanner>
      We&apos;re currently processing this file. Click to{' '}
      <ActionButton
        className={clsx('tw-underline tw-text-cfo-red-400', '!tw-p-0 !tw-mr-0 tw-ml-[3px]')}
        buttonType="style_unset"
        onClick={handleCancelAutomation}
      >
        Cancel
      </ActionButton>
    </AutomationBanner>
  );

  return (
    <>
      <TreatmentLayout
        header={Header}
        banner={Banner}
        isBackButtonDisabled={true}
      ></TreatmentLayout>
      <CancelAutomationModal />
    </>
  );
};

export default AutomationProcessingView;
